import React from "react";
import { Tooltip } from "@material-ui/core";
import { TextLabel } from "../../shared/components";
import InfoIcon from "@mui/icons-material/Info";
import dayjs from "dayjs";
import { PesoVisualMedioTooltip } from "./pesoVisualMedioTooltip";
import { t } from "adapters/i18n";

export const fechamentoConsumoInfo = ({ visualizacao, consumoFormula }) => {
  const {
    PeriodoBuscado,
    QuantidadeDiasConsumo,
    DataInicioConsumo,
    DataFimConsumo,
    DataPrimeiroAbastecimento,
    DataUltimoAbastecimento,
    TotalConsumidoFormula,
    TamanhoRebanho,
    QuantidadeAbastecida,
    PesoSaco,
    Granel,
    Versao,
    PesoVisualMedio,
  } = consumoFormula;

  const ehFechamentoConsumoDoBDW = () => Versao === "bdw";

  return (
    <div style={{ minHeight: 144 }} data-testid="fechamentoConsumoInfo">
      <div data-testid="PeriodoBuscado">
        <TextLabel color="default2" size={14} component="p">
          {t("supplementation:period-days")}:
        </TextLabel>
        <TextLabel color="default2" bold size={14} component="p">
          {` ${PeriodoBuscado}`}
        </TextLabel>
      </div>
      {(QuantidadeDiasConsumo || QuantidadeDiasConsumo === 0) && (
        <div
          style={{ display: "flex", gap: "8px", alignItems: "center" }}
          data-testid="QuantidadeDiasConsumo" >
          <div>
            <TextLabel color="default2" size={14} component="p">
              {t("supplementation:usage-days")}:
            </TextLabel>
            <TextLabel color="default2" bold size={14} component="p">
              {` ${QuantidadeDiasConsumo}`}
            </TextLabel>
          </div>
          <div style={{ display: "flex" }}>
            <Tooltip
              title={
                <ConsumoTooltip
                  dataInicioConsumo={DataInicioConsumo}
                  dataFimConsumo={DataFimConsumo}
                  dataPrimeiroAbastecimento={DataPrimeiroAbastecimento}
                  dataUltimoAbastecimento={DataUltimoAbastecimento}
                />
              }
              placement="right-start"
            >
              <InfoIcon
                color="primary"
                style={{ width: "15px", height: "15px" }}
              />
            </Tooltip>
          </div>
        </div>
      )}
      <Tooltip
        style={{ cursor: "pointer" }}
        title={t("supplementation:total-consumption-info")}
        arrow
      >
        <div data-testid="TotalConsumidoFormula">
          <TextLabel color="default2" size={14} component="p">
            {t("supplementation:total-consumption-kg")}:
          </TextLabel>
          <TextLabel color="default2" bold size={14} component="p">
            {` ${TotalConsumidoFormula || 0}`}
          </TextLabel>
        </div>
      </Tooltip>
      {TotalConsumidoFormula === 0 && (
        <div>
          <TextLabel color="error" size={10.5} component="p">
            {t("formulation:no-formulation-collect")}
          </TextLabel>
        </div>
      )}
      <Tooltip
        style={{ cursor: "pointer" }}
        title={t("supplementation:daily-count-info")}
        arrow
      >
        <div data-testid="TamanhoRebanho">
          <TextLabel color="default2" size={14} component="p">
            {t("supplementation:daily-count-plural")}:
          </TextLabel>
          <TextLabel color="default2" bold size={14} component="p">
            {` ${TamanhoRebanho}`}
          </TextLabel>
        </div>
      </Tooltip>
      <div data-testid="QuantidadeAbastecida">
        <TextLabel color="default2" size={14} component="p">
          {t("supplementation:supplied-quantity")}:
        </TextLabel>
        <TextLabel color="default2" bold size={14} component="p">
          {ehFechamentoConsumoDoBDW()
            ? ` ${QuantidadeAbastecida} `
            : ` ${(TotalConsumidoFormula || 0) / (Granel || PesoSaco)} `}

          {Granel ? t("common:measure.kg") : t("common:measure.bags")}
        </TextLabel>
      </div>

      {visualizacao !== "g/cab/dia" && (
        <div
          style={{ display: "flex", gap: "8px", alignItems: "center" }}
          data-testid="PesoVisualMedio">
          <div>
            <TextLabel color="default2" size={14} component="p">
              {t("statusIndicator:average-visual-weight")}:{" "}
            </TextLabel>
            <TextLabel color="default2" bold size={14} component="p">
              {PesoVisualMedio || 0} kg
            </TextLabel>
          </div>

          <div style={{ display: "flex" }}>
            <Tooltip title={<PesoVisualMedioTooltip />} placement="right-start">
              <InfoIcon
                color="primary"
                style={{ width: "15px", height: "15px" }}
              />
            </Tooltip>
          </div>
        </div>
      )}
    </div>
  );
};

const ConsumoTooltip = ({
  dataInicioConsumo,
  dataFimConsumo,
  dataPrimeiroAbastecimento,
  dataUltimoAbastecimento,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        fontFamily: "Roboto",
        padding: "2px",
      }}
    >
      <div>
        <div>
          <strong>Início consumo:</strong>{" "}
          {dataInicioConsumo
            ? dayjs(dataInicioConsumo).format("DD/MM/YYYY")
            : "-"}
        </div>
        <div>
          <strong>Fim consumo:</strong>{" "}
          {dataFimConsumo ? dayjs(dataFimConsumo).format("DD/MM/YYYY") : "-"}
        </div>
      </div>
      <div>
        <div>
          <strong>Primeiro abastecimento:</strong>{" "}
          {dataPrimeiroAbastecimento
            ? dayjs(dataPrimeiroAbastecimento).format("DD/MM/YYYY")
            : "-"}
        </div>
        <div>
          <strong>Último abastecimento:</strong>{" "}
          {dataUltimoAbastecimento
            ? dayjs(dataUltimoAbastecimento).format("DD/MM/YYYY")
            : "-"}
        </div>
      </div>
    </div>
  );
};

export default React.memo(fechamentoConsumoInfo, (props, nextProps) => {
  return (
    props.consumoFormula.ConsumoOcorrido ===
    nextProps.consumoFormula.ConsumoOcorrido &&
    props.visualizacao === nextProps.visualizacao
  );
});
